import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import i18n from '@/i18n'
import { detectLocale, getSiteLocaleCookie } from '@/lib/detect-locale'
import { syncDocumentLanguage } from '@/lib/intl/sync-document-language'
import { LOCAL_STORAGE_KEYS } from '@/lib/local-storage-keys'

export type Locale = 'enUs' | 'ptBr' | 'esEs' | 'frFr' | 'deDe' | 'itIt'

interface LanguageStore {
  locale: Locale
  setLocale: (locale: Locale) => void
}

export const useLanguageStore = create<LanguageStore>()(
  // @ts-ignore - Known issue with Zustand 5.x and TypeScript strict mode with persist middleware
  persist(
    (set) => ({
      // On first visit (no persisted value yet) honor the marketing-site choice
      // before falling back to the browser language. Once the user picks a
      // language in-app, the persisted value takes precedence on hydration.
      locale: getSiteLocaleCookie() ?? detectLocale(),

      setLocale: (locale) => {
        i18n.changeLanguage(locale)
        syncDocumentLanguage(locale)
        set({ locale })
      },
    }),
    {
      name: LOCAL_STORAGE_KEYS.LANGUAGE,
    },
  ),
)
